import { API_BASE_URL } from "@/config";
import { validateToken } from '@/utils/auth';

export default {
    name: 'ExperianCreditReportForm',
    data() {
        return {
            id_number: '',
            first_name: '',
            surname: '',
            gender: '',
            date_of_birth: '',
            error: ''
        };
    },
    emits: ['service_status_complete'],
    methods: {
        allow_number(event) {
            // Allow only numeric input for id_number field
            let value = event.target.value.replace(/[^0-9]/g, '');
            this.id_number = value;
        },
        validate_fields() {
            let is_valid = true;
            
            // Reset all error messages
            $('.id-number-message, .id-length-message, .id-invalid-message, .first-name-message, .surname-message, .gender-message, .dob-message, .dob-mismatch-message').addClass('d-none');
            
            // Validate ID Number
            if (!this.id_number.trim()) {
                $('.id-number-message').removeClass('d-none');
                setTimeout(() => $('.id-number-message').addClass('d-none'), 3000);
                is_valid = false;
            } else if (this.id_number.length !== 13) {
                $('.id-length-message').removeClass('d-none');
                setTimeout(() => $('.id-length-message').addClass('d-none'), 3000);
                is_valid = false;
            } else {
                // Validate date components in ID number
                var year = parseInt(this.id_number.substring(0, 2), 10);
                var month = parseInt(this.id_number.substring(2, 4), 10);
                var day = parseInt(this.id_number.substring(4, 6), 10);
                var full_year = year <= 21 ? 2000 + year : 1900 + year;

                if (month < 1 || month > 12 || day < 1 || day > 31) {
                    $('.id-invalid-message').removeClass('d-none');
                    setTimeout(() => $('.id-invalid-message').addClass('d-none'), 3000);
                    is_valid = false;
                } else {
                    var days_in_month = new Date(full_year, month, 0).getDate();
                    if (day > days_in_month) {
                        $('.id-invalid-message').removeClass('d-none');
                        setTimeout(() => $('.id-invalid-message').addClass('d-none'), 3000);
                        is_valid = false;
                    }
                }

                // Validate date of birth matches ID number
                if (this.date_of_birth && is_valid) {
                    var dob_parts = this.date_of_birth.replace(/\//g, '-').split('-');
                    var dob_year = parseInt(dob_parts[0], 10);
                    var dob_month = parseInt(dob_parts[1], 10);
                    var dob_day = parseInt(dob_parts[2], 10);

                    if (dob_year !== full_year || dob_month !== month || dob_day !== day) {
                        $('.dob-mismatch-message').removeClass('d-none');
                        setTimeout(() => $('.dob-mismatch-message').addClass('d-none'), 3000);
                        is_valid = false;
                    }
                }
            }

            // Validate First Name
            if (!this.first_name.trim()) {
                $('.first-name-message').removeClass('d-none');
                setTimeout(() => $('.first-name-message').addClass('d-none'), 3000);
                is_valid = false;
            }

            // Validate Surname
            if (!this.surname.trim()) {
                $('.surname-message').removeClass('d-none');
                setTimeout(() => $('.surname-message').addClass('d-none'), 3000);
                is_valid = false;
            }

            // Validate Gender
            if (!this.gender) {
                $('.gender-message').removeClass('d-none');
                setTimeout(() => $('.gender-message').addClass('d-none'), 3000);
                is_valid = false;
            }

            // Validate Date of Birth
            if (!this.date_of_birth) {
                $('.dob-message').removeClass('d-none');
                setTimeout(() => $('.dob-message').addClass('d-none'), 3000);
                is_valid = false;
            }

            return is_valid;
        },
        submit_form() {
            if (!this.validate_fields()) {
                return;
            }
            this.submit_experian();
        },
        submit_experian() {
            const TOKEN = localStorage.getItem('token');
            const API_URL = `${API_BASE_URL}/verify_api/instant_verify_api/experian_credit_report/`;

            this.error = '';

            $.ajax({
                url: API_URL,
                method: 'POST',
                contentType: 'application/json',
                headers: {
                    Authorization: `Token ${TOKEN}`
                },
                data: JSON.stringify({
                    id_number: this.id_number,
                    first_name: this.first_name,
                    surname: this.surname,
                    gender: this.gender,
                    date_of_birth: this.date_of_birth
                }),
                beforeSend: () => {
                    Swal.fire({
                        text: 'Loading ...',
                        allowEscapeKey: false,
                        allowOutsideClick: false,
                        didOpen: () => Swal.showLoading()
                    });
                },
                success: () => {
                    Swal.close();
                    Swal.fire({
                        icon: 'success',
                        title: 'Successful',
                        text: 'Experian Credit Report retrieved successfully',
                        timer: 3000,
                        timerProgressBar: true,
                        showConfirmButton: false
                    }).then(() => {
                        this.$emit('service_status_complete');
                        this.id_number = '';
                        this.first_name = '';
                        this.surname = '';
                        this.gender = '';
                        this.date_of_birth = '';
                    });
                },
                error: (error) => {
                    Swal.close();
                    let error_message = 'An error occurred while retrieving Experian credit report.';
                    if (error.responseJSON && error.responseJSON.error) {
                        error_message = error.responseJSON.error;
                    } else if (error.responseJSON && error.responseJSON.message) {
                        error_message = error.responseJSON.message;
                    }
                    Swal.fire({
                        icon: 'error',
                        title: 'Error',
                        text: error_message,
                        confirmButtonText: 'OK'
                    });
                }
            });
        }
    },
    mounted() {
        if (!validateToken(this.$router)) {
            return;
        }
    }
};
